import { gql } from "@apollo/client";

export const GET_EVENTS = gql`
  query GetEvents($tradeId: Int) {
    events(tradeId: $tradeId) {
      id
      tradeId
      type
      date
      description
      probability
      projectedIncrease
      targetPrice
      stopLoss
      eventType
      status
      impact
    }
  }
`;

export const GET_UPCOMING_EVENTS = gql`
  query GetUpcomingEvents($limit: Int) {
    upcomingEvents(limit: $limit) {
      id
      tradeId
      type
      date
      description
      probability
      projectedIncrease
      targetPrice
      stopLoss
      eventType
      status
      impact
    }
  }
`;

export const GET_EVENTS_BY_DATE = gql`
  query GetEventsByDate($date: DateTime!) {
    eventsByDate(date: $date) {
      id
      tradeId
      type
      date
      description
      probability
      projectedIncrease
      targetPrice
      stopLoss
      eventType
      status
      impact
    }
  }
`;

export const GET_EVENTS_BY_DATE_RANGE = gql`
  query GetEventsByDateRange($startDate: DateTime!, $endDate: DateTime!) {
    eventsByDateRange(startDate: $startDate, endDate: $endDate) {
      id
      tradeId
      type
      date
      description
      probability
      projectedIncrease
      targetPrice
      stopLoss
      eventType
      status
      impact
    }
  }
`;

export const CREATE_EVENT = gql`
  mutation CreateEvent($data: CreateEventInput!) {
    createEvent(data: $data) {
      id
      tradeId
      type
      date
      description
      probability
      projectedIncrease
      targetPrice
      stopLoss
      eventType
      status
      impact
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent($id: Int!, $data: UpdateEventInput!) {
    updateEvent(id: $id, data: $data) {
      id
      tradeId
      type
      date
      description
      probability
      projectedIncrease
      targetPrice
      stopLoss
      eventType
      status
      impact
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation DeleteEvent($id: Int!) {
    deleteEvent(id: $id) {
      id
    }
  }
`;
